import React, { Component } from 'react';

import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement
} from 'react-stripe-elements';

const createOptions = function() {
  return {
    style: {
      base: {
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: 'Source Code Pro, monospace',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };
};

class _CardForm extends Component {
  constructor(props) {
    super(props);

    // Add stripe to the main props package 
    this.props.updateField('stripe', this.props.stripe);
  }

  render() {
    return (
      <div>
        <label>
          Card number
          <CardNumberElement
            onChange={(e) => {this.props.updateField('cardNumber', e.complete);}}
            {...createOptions()}
          />
        </label>
        <div className='container'>
          <label>
            Expiration date
            <CardExpiryElement
              onChange={(e) => {this.props.updateField('expiry', e.complete);}}
              {...createOptions()}
            />
          </label>
          <label>
            CVC
            <CardCVCElement
              onChange={(e) => {this.props.updateField('cvc', e.complete);}}
              {...createOptions()}
            />
          </label>
        </div>
        <img src={'./default/payment-mode-icon.png'} alt="secure" className="stripe-image"/>
      </div>
    )
  }
}

export default _CardForm


// WEBPACK FOOTER //
// ./src/app/components/elements/StripeElement.js